import { useTranslation } from 'react-i18next';

import { Reveal } from 'src/components/reveal';
import { SectionHead } from 'src/components/section-head';

export function HomeFaq() {
  const { t } = useTranslation('home');
  const items = t('faq.items', { returnObjects: true });

  return (
    <section className="section day">
      <div className="container">
        <SectionHead lead={t('faq.lead')} title={t('faq.title')} eyebrow={t('faq.eyebrow')} />
        <Reveal className="faq">
          {items.map((item) => (
            <details key={item.question}>
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
